import apiClient from 'utilities/apiClient';

export const profileView = (payload) => {
  return apiClient.get(
    `${apiClient.Urls.profileView}/${payload}`,
    payload,
    true
  );
};

// profileActions
export const profileActions = (url, payload) => {
  return apiClient.post(
    `${apiClient.Urls.profile_actions}/${url}`,
    payload,
    true
  );
};

// respondRequestAction
export const respondRequestAction = (url, payload) => {
  return apiClient.patch(
    `${apiClient.Urls.profile_actions}/${url}`,
    payload,
    true
  );
};

// blockingProfile
export const blockingProfile = (url, payload) => {
  return apiClient.post(
    `${apiClient.Urls.createdetails}/${url}`,
    payload,
    true
  );
};

// profileDownloads
export const profileDownloads = (url, payload) => {
  return apiClient.get(
    `${apiClient.Urls.profile_downloads}/${url}`,
    payload,
    true
  );
};
